module.exports = __webpack_public_path__ + "img/ercode_haveaddress.b50f21a8.png";